import { Controller } from "@hotwired/stimulus"
import { nodeIdFromUrl } from "global/javascript/utils"
import { isbot } from "isbot"

export default class extends Controller {
  static values = { disabledSinglePage: Boolean }

  static DOC_INTRO_ID = "doc-introduction"

  initialize() {
    // We are running Javascript so we can remove the 'no-js' CSS
    // class. This has the effect to display all turbo frames which
    // each take 100% of the viewport height. And thus “moves” the
    // current position of the scroll.
    // Remove CSS class added by default during rendering of docs
    if (!this.disabledSinglePageValue && !isbot(navigator.userAgent)) {
      this.element.classList.remove("no-single-page-xp")
      // This is needed by previews, when page is refreshed via a
      // WebSocket, and we trigger a DOMContentLoaded event
      document.addEventListener("DOMContentLoaded", () => {
        this.element.classList.remove("no-single-page-xp")
      })
    }

    this.#setActiveItem()

    // We now need to maintain the position to the original place
    // where we were.

    // TODO: The following highlighting shouldn't be done here but
    // it's kept for current backward compatibility (it will be moved
    // to the Highlight controller when the hash contains a
    // highlighting information)
    this.#highlight()
    this.dispatch("goTo", { target: document, detail: { element: this.activeItem }, prefix: false })
  }

  #setActiveItem() {
    const currentUrl = new URL(window.location.href)
    let activeId = nodeIdFromUrl(currentUrl)
    let activeItem = document.getElementById(activeId)

    if (window.location.hash && !activeItem) {
      // Unset URL hash if not item found
      currentUrl.hash = ""
      const parentId = nodeIdFromUrl(currentUrl)
      const parentItem = document.getElementById(parentId)

      // Update current location hash if we found a parent item
      if (parentItem) {
        window.location.hash = parentId
        activeItem = parentItem
      }
    }

    if (!activeItem) {
      activeId = this.constructor.DOC_INTRO_ID
      activeItem = document.getElementById(activeId)
    }

    this.activeItem = activeItem
  }

  // Display highlight on the active item, only if there's a fragment
  // in the URL. Except on the root node (doc introduction).
  #highlight() {
    if (window.location.hash != "") {
      this.dispatch("highlight", { target: document, detail: {element: this.activeItem}, prefix: false })
    }
  }
}
